import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AntennasQuery } from 'src/app/store/antennas/state/antennas.query';
import { AntennasState, AntennasStore } from 'src/app/store/antennas/state/antennas.store';
import { SubSink } from 'subsink';

type AntennasCheckBox = Record<keyof AntennasState, FormControl>;

@Component({
  selector: 'app-antennas',
  templateUrl: './antennas.component.html',
  styleUrls: ['./antennas.component.scss'],
})
export class AntennasComponent implements OnInit, OnDestroy {
  constructor(private store: AntennasStore, private query: AntennasQuery) {}
  selectedOptions: AntennasState;
  formControls: AntennasCheckBox = {
    getterAntenna: new FormControl(false),
    selfAntenna: new FormControl(false),
  };

  antennasFormGroup = new FormGroup(this.formControls);
  subs = new SubSink();
  ngOnInit(): void {
    this.antennasFormGroup.patchValue(this.store.getValue(), { emitEvent: false });
    this.selectedOptions = this.store.getValue();
    this.subs.sink = this.antennasFormGroup.valueChanges.subscribe((x) =>
      this.store.update(x)
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
